(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulveo-help-center"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ulveo-help-center')) return;

    /* Recherche insensible aux accents et à la casse. */
    const normalize = (text) =>
      text
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase();

    class UlveoHelpCenter extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-hc-item]'));
        this.groups = Array.from(this.querySelectorAll('[data-hc-group]'));
        this.empty = this.querySelector('[data-hc-empty]');
        this.status = this.querySelector('[data-hc-status]');
        this.form = this.querySelector('[data-hc-search]');
        this.input = this.querySelector('[data-hc-input]');
        this.clear = this.querySelector('[data-hc-clear]');

        if (this.form && this.input) {
          this.form.hidden = false;
          this.index = this.items.map((item) => normalize(item.textContent));
          this.input.addEventListener('input', () => this.filter());
          this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            const first = this.items.find((item) => !item.hidden);
            if (first) {
              first.open = true;
              first.querySelector('summary').focus();
            }
          });
          if (this.clear) {
            this.clear.addEventListener('click', () => {
              this.input.value = '';
              this.filter();
              this.input.focus();
            });
          }
        }

        this.onHash = () => this.openFromHash();
        window.addEventListener('hashchange', this.onHash);
        this.openFromHash();
        this.watchTopics();
      }

      disconnectedCallback() {
        window.removeEventListener('hashchange', this.onHash);
        if (this.observer) this.observer.disconnect();
      }

      filter() {
        const terms = normalize(this.input.value.trim()).split(/\s+/).filter(Boolean);
        let count = 0;

        this.items.forEach((item, i) => {
          const match = terms.every((term) => this.index[i].includes(term));
          item.hidden = !match;
          if (match) count += 1;
        });
        this.groups.forEach((group) => {
          group.hidden = !group.querySelector('[data-hc-item]:not([hidden])');
        });

        this.toggleAttribute('data-searching', terms.length > 0);
        if (this.clear) this.clear.hidden = this.input.value === '';
        if (this.empty) this.empty.hidden = count > 0;

        if (this.status) {
          window.clearTimeout(this.statusTimer);
          this.statusTimer = window.setTimeout(() => {
            if (!terms.length) this.status.textContent = '';
            else if (count === 0) this.status.textContent = 'Aucune réponse trouvée.';
            else this.status.textContent = count === 1 ? '1 réponse trouvée.' : `${count} réponses trouvées.`;
          }, 400);
        }
      }

      /* Un lien vers /pages/aide#une-question ouvre directement la réponse. */
      openFromHash() {
        let id = '';
        try {
          id = decodeURIComponent(window.location.hash.slice(1));
        } catch (error) {
          return;
        }
        if (!id) return;
        const target = document.getElementById(id);
        if (target && this.contains(target) && target.matches('details')) target.open = true;
      }

      /* Sommaire : la rubrique en cours de lecture est signalée. */
      watchTopics() {
        const links = Array.from(this.querySelectorAll('[data-hc-topic-link]'));
        if (!links.length || !('IntersectionObserver' in window)) return;

        const byId = new Map(links.map((link) => [decodeURIComponent(link.hash.slice(1)), link]));
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              links.forEach((link) => link.removeAttribute('aria-current'));
              const link = byId.get(entry.target.id);
              if (link) link.setAttribute('aria-current', 'true');
            });
          },
          { rootMargin: '-35% 0px -60% 0px' }
        );
        this.groups.forEach((group) => {
          if (group.id) this.observer.observe(group);
        });
      }
    }

    customElements.define('ulveo-help-center', UlveoHelpCenter);
  })();

  } catch(e) { console.error(e); }
})();
})();
